module.exports = __webpack_public_path__ + "img/hosting.7919038f.png";